import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { FadeView } from '../../../FadeView';

// ─────────────────────────────────────────────────────────────────────────────

export const QuantityStepperFloatingContainer = (props: Props) => {
  const { size = 'md', isShown, children } = props;

  const containerStyles = [
    styles.container,
    size === 'md' ? styles.containerMD : styles.containerLG,
  ];

  return (
    <FadeView show={isShown} duration={theme.transitions.short} style={styles.outerContainer}>
      <View style={containerStyles}>{children}</View>
    </FadeView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTAINER_PADDING = theme.spacing['1'];
const CONTAINER_MIN_WIDTH_MD = 154;
const CONTAINER_MIN_WIDTH_LG = 175;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    position: 'absolute',
    top: -CONTAINER_PADDING,
    right: -CONTAINER_PADDING,
    zIndex: theme.zIndex.dropdown,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.WHITE,
    padding: CONTAINER_PADDING,
  },
  containerMD: {
    minWidth: CONTAINER_MIN_WIDTH_MD,
    borderRadius: 30,
  },
  containerLG: {
    minWidth: CONTAINER_MIN_WIDTH_LG,
    borderRadius: 40,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  isShown: boolean;
  size?: 'md' | 'lg';
}>;
